<template>
    <b-row class="d-flex flex-nowrap row">
        <div style="margin-left: 1rem; display:flex; align-items: center;">
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Rango fecha</label>
            <date-range-picker 
                :value="date"
                @input="updateDate"
                min="2020-1-1"
                max="2026-12-31"
                :dayStr="dayStr"
                :scrollbarProps="{isMobile: false}"
                :rangeSeparator="rangeSeparator"
                :secondPlaceholder="secondPlaceholder"
                :placeholder="placeholder"
                :firstDayOfWeek="firstDayOfWeek"
                :monthStr="monthStr"
            />
        </div>
        <div style="margin-left: 1rem">
            <label class="mr-sm-2" for="inline-form-custom-select-pref">Guía</label>
            <b-form-select v-model="busCompanyId" @input="updateBusCompany">
                <option :value="0">Seleccione un compañía de buses</option>
                <option
                    v-for="company in busCompanies"
                    :key="company.id"
                    :label="company.name"
                    :value="company.id"
                >
                    {{ company.name }}
                </option>
            </b-form-select>
        </div>
        <div style="margin-left: 1rem">
            <b-button
                @click="trigger"
                class="border"
                size="sm"
                variant="light"
            >
                <i class="text-center fa fa-search fa-fw"></i>
                Buscar
            </b-button>
        </div>
    </b-row>
</template>

<script>
/* eslint-disable */

import { mapGetters } from "vuex";
import { DateRangePicker } from '@livelybone/vue-datepicker';

export default {
    components: {
        DateRangePicker
    },
    props: {
        trigger: {
            type: Function,
            required: false
        }
    },
    data: function () {
        
        return {
            dayStr: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            monthStr: ['Enero', 'Febrero', 'Marzo', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            date: [null, null],
            isM: false,
            rangeSeparator: "/", 
            secondPlaceholder: "Seleccionar",
            placeholder: "Seleccionar",
            firstDayOfWeek: 1,
            busCompanyId: 0
        }
    },
    methods: {
        updateDate: function(val) {
            this.date = val
            console.log(val)
            // set filter in store
            let filter = {
                day_init: this.date[0],
                day_end: this.date[1],
                bus_company_id: this.busCompaniesAnalyticsFilter.bus_company_id
            }
            this.$store.dispatch("analytics/updateBusCompanyFilter", filter)
        },
        updateBusCompany() {
            let filter = {
                bus_company_id: this.busCompanyId
            }
            this.$store.dispatch("analytics/updateBusCompanyFilter", filter)
        }
    },
    computed: {
        ...mapGetters(["busCompaniesBreakdown", "busCompanies", "busCompaniesAnalyticsFilter"]),
    },
    mounted() {
        this.$store.dispatch("buscompanies/retrieveBusCompanies")
        const filter = this.busCompaniesAnalyticsFilter
        let startOfMonth = filter.day_init
        let endOfMonth = filter.day_end
        if ( filter.day_init == null ) {
            startOfMonth = this.$moment().startOf('month').format('YYYY-MM-DD');
            this.$store.dispatch("analytics/updateBusCompanyFilter", {day_init: startOfMonth})
        }
        if ( filter.day_end == null ) {
            endOfMonth = this.$moment().endOf('month').format('YYYY-MM-DD');
            this.$store.dispatch("analytics/updateBusCompanyFilter", {day_end: endOfMonth})
        }
        if ( filter.bus_company_id != null ) {
            this.busCompanyId = filter.bus_company_id
        }
        this.date = [startOfMonth, endOfMonth]
    },
}
</script>


<style lang="css" src="@livelybone/vue-datepicker/lib/css/index.css"></style>

<style > 
.datepicker, .date-range-picker, .timepicker, .datetime-picker {
    height: 30px !important;
}
.datepicker .input-wrapper, .date-range-picker .input-wrapper, .timepicker .input-wrapper, .datetime-picker .input-wrapper {
    border: 1px solid #999 !important;
    border-radius: 0px !important;
}
.date-range-picker .vue-input {
    font-size: 12px !important;
}
.date-range-picker .picker .picker-items .row-item .item.is-in-range::before {
    background: #e7ce28;
}
.date-range-picker .picker .picker-items .row-item .item.selected::before {
    background: #080700;
    border-radius: 3px;
} 
.date-range-picker .picker .picker-items .row-item .item.is-now {
    color: black;
    font-weight: bold;
}
</style>